import { useCustomerPageContext } from "@contexts/customer"
import { Stack } from "@mui/material"
import Box from "@mui/material/Box"
import Tab from "@mui/material/Tab"
import Tabs from "@mui/material/Tabs"
import CustomerAiTestPage from "@pages/customer/infos/tabs/ai_test"
import CustomerCampaignLinksPage from "@pages/customer/infos/tabs/campaign_links"
import CustomerCompanyPage from "@pages/customer/infos/tabs/company"
import CustomerDetailPage from "@pages/customer/infos/tabs/customer"
import CustomersPageInvoices from "@pages/customer/infos/tabs/invoices"
import CustomerPlanPage from "@pages/customer/infos/tabs/plan_billing"
import CustomerUsersPage from "@pages/customer/infos/tabs/users"
import * as React from "react"
import styles from "./styles"

interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Stack>{children}</Stack>}
    </div>
  )
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`
  }
}

export default function InfosTabs() {
  const { setTabsValue, tabsValue, translate, currentCustomer } =
    useCustomerPageContext()

  const hasAiFeature = !!currentCustomer?.package?.features?.ai

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabsValue?.(newValue)
  }

  return (
    <Box sx={styles.containerWidth} p={2}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={tabsValue} onChange={handleChange}>
          <Tab label={translate("customer")} {...a11yProps(0)} />
          <Tab label={translate("company")} {...a11yProps(1)} />
          <Tab label={translate("plans")} {...a11yProps(2)} />
          <Tab label={translate("users")} {...a11yProps(3)} />
          <Tab label={translate("invoces")} {...a11yProps(4)} />
          <Tab
            label={translate("ai_simulation")}
            disabled={!hasAiFeature}
            {...a11yProps(5)}
          />
          <Tab label={translate("campaign_links_tab")} {...a11yProps(6)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={tabsValue} index={0}>
        <CustomerDetailPage />
      </CustomTabPanel>
      <CustomTabPanel value={tabsValue} index={1}>
        <CustomerCompanyPage />
      </CustomTabPanel>
      <CustomTabPanel value={tabsValue} index={2}>
        <CustomerPlanPage />
      </CustomTabPanel>
      <CustomTabPanel value={tabsValue} index={3}>
        <CustomerUsersPage />
      </CustomTabPanel>
      <CustomTabPanel value={tabsValue} index={4}>
        <CustomersPageInvoices />
      </CustomTabPanel>
      <CustomTabPanel value={tabsValue} index={5}>
        <CustomerAiTestPage />
      </CustomTabPanel>
      <CustomTabPanel value={tabsValue} index={6}>
        <CustomerCampaignLinksPage />
      </CustomTabPanel>
    </Box>
  )
}
